import React, { useState, useEffect } from 'react'
import HeaderAdmin from "../Components/HeaderAdmin/Header";
import Loader2 from "../DashboardPages/DashboardComponents/Loader/Loader2";
import { Link } from "react-router-dom";
import { IoClose, IoCloseSharp } from 'react-icons/io5';
import { useHistory } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { MdOutlineModeEdit } from 'react-icons/md';
import Spinner from 'react-bootstrap/Spinner';
import { useParams } from 'react-router-dom';
import { addnotes, getnotes } from "../../src/Api/prescriptionApis"
import { getorderbydata, updateorderdata, deleteorder, updateorderstatus, getactivefitters } from '../Api/iron'
import { TfiReload } from "react-icons/tfi";
import Modal from 'react-bootstrap/Modal';
import { getCurrentUser } from "../Api/auth";
import Button from 'react-bootstrap/Button';



function FitterBuilderOrder() {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const goBack = () => {
        history.goBack();
    };

    const toggleDropdown2 = () => {
        setIsOpen2(!isOpen2);
    };

    const selectOption2 = (option) => {
        setSelectedOption2(option.text);
        setSelectionId(option.id);
    };


    const getColorClass = () => {
        const selectedColor = options2.find(opt => opt.text === selectedOption2)?.color;
        return selectedColor ? selectedColor : 'white';
    };

    const [isOpen2, setIsOpen2] = useState(false);
    const [selectedOption2, setSelectedOption2] = useState('Inquiry');
    const [selectionid, setSelectionId] = useState(0);
    const [dbselectionid, setdbselectionid] = useState(0);
    const [apicallupate, setApicallupdate] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);


    const handlegetnotes = () => {
        const data = {
            project_id: params.id
        }
        getnotes(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setnotesData(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setValidated(true);
        });
    };

    const handleaddnotes = () => {
        setApicall(true);

        if (notes === "") {
            setShowererror(true);
            setApicall(false);
            return false;
        }

        const data = {
            notes: notes,
            user_id: userid,
            fitter_id: userid,
            project_id: params.id
        }

        addnotes(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                handlegetnotes();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setShowererror(false);
            setApicall(false);
            setValidated(true);
            setnotes('');
        });
    };

    const [notes, setnotes] = useState('');
    const [showerror, setShowererror] = useState(false);
    const [apicall, setApicall] = useState(false);
    const [notesdata, setnotesData] = useState([]);

    const options2 = [
        { text: 'Inquiry', color: 'orange', id: 0 },
        { text: 'Contacted', color: 'yellow', id: 1 },
        { text: 'Invoiced', color: 'green', id: 2 },
        { text: 'Purchased', color: 'blue', id: 3 },
        { text: 'Shipped', color: 'white', id: 4 }
    ];

    const params = useParams();
    const [userid, setUserid] = useState(0);
    const [fitter_id, setFitter_id] = useState(0);
    const [validated, setValidated] = useState(false);

    const [formData, setFormData] = useState({
        poTagName: "",
        deliveryAddress: "",
        deliveryNotes: "",
        dexterity: "",
        finish: "",
        bounce: "",
        weightNotes: "",
        generalNotes: "",
        email: "",
        phone: "",
        business_name: "",
    });

    const [isEditing, setIsEditing] = useState(false);

    const setEditable = () => {
        setIsEditing(!isEditing);
    };

    const [items, setItems] = useState([]);
    const finishes = [{ "name": "Black", "id": 1 }, { "name": "Silver", "id": 2 }, { "name": "Gold", id: 3 }, { "name": "Dark Blue", id: 4 }, { "name": "Light Blue", "id": 5 }, { "name": "Green", "id": 6 }, { "name": "Emerald", "id": 7 }, { "name": "Ruby Red", "id": 8 }];

    const weightsByFinish = {
        1: ['1g', '2g', '6g', '8g', '10g'],   // Black
        2: ['2g', '6g'],                      // Silver
        3: ['1g', '6g'],                      // Gold
        4: ['6g'],                            // Dark Blue
        5: ['1g'],                            // Light Blue
        6: ['1g'],                            // Green
        7: ['1g'],                            // Emerald
        8: ['1g']                             // Ruby Red
    };

    const sizearray = ['Regular', "Slim"];
    const counterweight = ['6g', '12g', '18g', '24g']

    // const quantity = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    const quantity = Array.from({ length: 100 }, (_, i) => i + 1);


    const [ironsets, setIronsets] = useState([]);

    const [countersets, setCountersets] = useState([]);

    const weights = [];
    for (let i = 40; i <= 90; i += 5) {
        weights.push(i);
    }


    const addItem = () => {
        const newItem = { id: Date.now(), finish: "Finish", weight: "Weight", qty: "Qty" };
        setItems([...items, newItem]);
    };

    const addirons = () => {
        const newironset = { id: Date.now(), dexterity: "Dexterity", finish: "Finish", bounces: "Bounces" };
        setIronsets([...ironsets, newironset]);
    };

    const addCounters = () => {
        const newironset = { id: Date.now(), size: "Size", weight: "Weight", qty: "Qty" };
        setCountersets([...countersets, newironset]);
    };

    const removeItem = (id) => {
        setItems(items.filter((item) => item.id !== id));
    };

    const handleChange = (id, field, value) => {
        setItems(items.map(item => item.id === id ? { ...item, [field]: value } : item));
    };

    const handleChangeiron = (id, field, value) => {
        setIronsets(ironsets.map(ironset => ironset.id === id ? { ...ironset, [field]: value } : ironset));
    };

    const handleChangecounter = (id, field, value) => {
        setCountersets(countersets.map(counterset => counterset.id === id ? { ...counterset, [field]: value } : counterset));
    }

    const removeCounter = (id) => {
        setCountersets(countersets.filter((counterset) => counterset.id !== id));
    }


    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const getorderdetailsfunc = () => {
        setIsLoading(true);

        const data = {
            _id: params.id
        }
        getorderbydata(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setFormData({
                    poTagName: data.poTagName,
                    deliveryAddress: data.deliveryAddress,
                    deliveryNotes: data.deliveryNotes,
                    dexterity: data.dexterity,
                    finish: data.finish,
                    bounce: data.bounce,
                    weightNotes: data.weightNotes,
                    generalNotes: data.generalNotes,
                    email: data.email,
                    phone: data.phone,
                    business_name: data.business_name,
                });
                setSelectedOption2(getstatusname(data?.status))
                setSelectionId(data.status);
                setdbselectionid(data.status);
                setFitter_id(data.fitter_id);


                if (Array.isArray(data.PortWeights)) {
                    setItems(
                        data.PortWeights.map((item, index) => ({
                            id: item.id,  // Ensure unique ID
                            finish: item.finish || "Finish",
                            weight: item.weight || "Weight",
                            qty: item.qty || "Qty"
                        }))
                    );
                } else {
                    setItems([]); // Default if no data
                }

                if (Array.isArray(data.IronSet)) {
                    setIronsets(
                        data.IronSet.map((item, index) => ({
                            id: item.id,  // Ensure unique ID
                            dexterity: item.dexterity || "Dexterity",
                            finish: item.finish || "Finish",
                            bounce: item.bounce || "Bounces"
                        }))
                    );
                } else {
                    setIronsets([]) // Default if no data
                }
                if (Array.isArray(data.CounterWeights)) {
                    setCountersets(
                        data.CounterWeights.map((item, index) => ({
                            id: item.id,  // Ensure unique ID
                            size: item.size || "Size",
                            weight: item.weight || "Weight",
                            qty: item.qty || "Qty"
                        }))
                    );
                } else {
                    setCountersets([]) // Default if no data
                }
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            // setValidated(true);
            setIsLoading(false);
        });
    };

    useEffect(() => {
        getorderdetailsfunc();
        getactivefittersfunc()

        const getCurrentUserdata = getCurrentUser();
        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserid(getCurrentUserdata.user._id);
        } else {
            console.error("Current user data is null or undefined");
        }
    }, []);

    const [apiupate, setApiupdate] = useState(false);

    const handleupdatedata = () => {
        setApiupdate(true);
        const data = {
            _id: params.id,
            poTagName: formData.poTagName,
            deliveryAddress: formData.deliveryAddress,
            deliveryNotes: formData.deliveryNotes,
            dexterity: formData.dexterity,
            finish: formData.finish,
            bounce: formData.bounce,
            weightNotes: formData.weightNotes,
            generalNotes: formData.generalNotes,
            email: formData.email,
            phone: formData.phone,
            business_name: formData.business_name,
            PortWeights: items,
            IronSet: ironsets,
            CounterWeights: countersets
        }


        updateorderdata(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                handlegetnotes();
                setApiupdate(false);
                setIsEditing(false);
                getorderdetailsfunc();
                handleShow();
            }
        }
        ).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApiupdate(false);
            setValidated(true);
        });
    }

    const getstatusname = (status) => {
        switch (status) {
            case 0:
                return 'Inquiry';
            case 1:
                return 'Contacted';
            case 2:
                return 'Invoiced';
            case 3:
                return 'Purchased';
            case 4:
                return 'Shipped';
            default:
                return 'Unknown'; // In case the status doesn't match any case
        }
    }


    const updateStagestatus = (e) => {
        setApicallupdate(true);

        const data = {
            _id: params.id,
            status: selectionid
        }

        updateorderstatus(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                handlegetnotes();
                setApicallupdate(false);
                getorderdetailsfunc();
                handleShow();
                toggleDropdown2();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicallupdate(false);
            setValidated(true);
        });
    };

    const handleCloseConfirmation2 = () => setShowConfirmation2(false);
    const handleShowConfirmation2 = () => setShowConfirmation2(true);
    const [showConfirmation2, setShowConfirmation2] = useState(false);

    const deleteorderfunc = () => {
        setApiupdate(true);

        const data = {
            _id: params.id
        }
        deleteorder(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                //please go only one step before
                history.goBack();
            }
        }
        ).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApiupdate(false);
            setValidated(true);
        });
    }


    const [activefitters, setActiveFitters] = useState([]);

    const getactivefittersfunc = () => {
        const data = {
            _id: params.id
        }
        getactivefitters(data).then((response) => {
            if (!response.data.status) {
                console.log("res.data.error", response.data.error);
            } else {
                const data = response.data.data;
                setActiveFitters(data);
            }
        }).catch((err) => {
            console.log(err);
        });

    }

    const NewhandleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        if (activefitters.length > 0) {
            //fiter data from activefitters array and update
            const filteredFitter = activefitters.filter((item) => item._id === value);
            if (filteredFitter.length > 0) {
                setFormData({ ...formData, business_name: filteredFitter[0]._id, email: filteredFitter[0].email, phone: filteredFitter[0].phone, deliveryAddress: filteredFitter[0].shipping_address });
            }

        };

    }
    return (
        <>
            {
                isLoading ? (
                    <div className="loading">
                        <Loader2 />
                    </div>
                ) : (
                    <>
                        <Modal
                            show={show} // Show the modal when `show` is true
                            onHide={handleClose}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <h3 className="text-center">Data update successfully</h3>
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={showConfirmation2}
                            onHide={handleCloseConfirmation2}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="confirmation-content text-center">
                                    <h4>Are you sure you want to remove order?</h4>
                                    <div className="confirmation-buttons d-flex align-items-center justify-content-between gap-2 mt-4">
                                        {
                                            apiupate ? (<Button variant="success" disabled style={{ maxWidth: "3.5rem" }}>...Removing order</Button>) : (<Button variant="success" onClick={deleteorderfunc} style={{ maxWidth: "3.5rem" }}>Yes</Button>)
                                        }

                                        {' '}
                                        <Button variant="danger" onClick={() => {
                                            handleCloseConfirmation2();
                                        }} style={{ maxWidth: "3.5rem" }}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <div className="main-page-body-content-header">
                            <HeaderAdmin />
                        </div>
                        <div className='design_show_mobile'>
                            <div className='fixed-btn'>
                                <Link to="/fitter-customer">
                                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#1e2024"><path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><path clip-rule="evenodd" d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z" fill-rule="evenodd" /></g></svg>
                                </Link>
                            </div>
                        </div>

                        <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec inline-btn-dashboard">
                            <div className="main-container">
                                <div className="main-page-body-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                <div className="sec-header-new">
                                                    <button type="button" className="btn-header-transparent">
                                                        <div className="border_box_view">
                                                            <div className="border_box_view_inner">
                                                                <div className="box_text_content">
                                                                    <div className="big_text">Fitter Order</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </button>
                                                    <div className="header-left">
                                                        <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                            <div className="border_box_view">
                                                                <div className="border_box_view_inner">
                                                                    <div className="box_icon">
                                                                        <IoCloseSharp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="dashboard-sec">
                                                    <div className="row">
                                                        <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open db_col">
                                                            <div className='black_bg_box mt-0'>
                                                                <div class="add-golfer-header">
                                                                    <div class="add-golfer-header-text" style={{ color: "#f3fcff" }}>
                                                                        <h3>Order Info</h3>
                                                                    </div>
                                                                    <div>
                                                                        {
                                                                            isEditing ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-close me-3"
                                                                                    aria-label="Submit"
                                                                                    onClick={handleupdatedata}
                                                                                >
                                                                                    {apiupate ? <Spinner animation="border" className="border-black" /> : <TfiReload />}
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-close me-3"
                                                                                    aria-label="Close"
                                                                                    onClick={() => setEditable(true)}
                                                                                >
                                                                                    <MdOutlineModeEdit />
                                                                                </button>
                                                                            )
                                                                        }

                                                                    </div>
                                                                </div>
                                                                <div className='modal-long-form'>
                                                                    <Form noValidate>
                                                                        <div className="row gap-4">
                                                                            <div className='row pe-0' controlid="validationCustom011">
                                                                                <div className='col-6 col-md-6 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <select className="form-select dashboard-input-box-3 select-custom-boxx" placeholder="Business Name" aria-label="Default select example" required name="business_name" value={formData.business_name} onChange={NewhandleFormChange} disabled={!isEditing}>
                                                                                            <option value="" selected disabled>Business Name</option>
                                                                                            {
                                                                                                activefitters.map((item, index) => (
                                                                                                    <option key={index} value={item._id}>{item.business_name}</option>
                                                                                                ))
                                                                                            }
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                                <div className='col-6 col-md-6 md-5 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <input type="text" class="form-control dashboard-input-box-3" placeholder="PO / Tag  Name" required name="poTagName" value={formData.poTagName} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom013">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <input type="text" class="form-control dashboard-input-box-3" placeholder="Phone" required name="phone" value={formData.phone} onChange={handleFormChange} disabled />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom014">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <input type="email" class="form-control dashboard-input-box-3" placeholder="Email" required name="email" value={formData.email} onChange={handleFormChange} disabled />

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom015">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <textarea type="text" class="form-control dashboard-input-box-3" placeholder="Delivery Address" style={{ height: "100px" }} required name="deliveryAddress" value={formData.deliveryAddress} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom016">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <textarea type="text" class="form-control dashboard-input-box-3" placeholder="Delivery / Customs Notes" style={{ height: "100px" }} required name="deliveryNotes" value={formData.deliveryNotes} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="add-golfer-header mb-0 mt-3">
                                                                                <div class="add-golfer-header-text" style={{ color: "#f3fcff" }}>
                                                                                    <h3>Iron Set</h3>
                                                                                </div>
                                                                                <button type="button" className="btn-close" aria-label="Close" onClick={addirons} disabled={ironsets.length === 1 || !isEditing}>
                                                                                    <FaPlus size={22} />
                                                                                </button>
                                                                            </div>
                                                                            {ironsets.map((item) => (
                                                                                <>
                                                                                    <div className='row pe-0' controlid="validationCustom016">
                                                                                        <div className='col-md-12 pe-0'>
                                                                                            <div className='form-group-input'>
                                                                                                <select className="form-select dashboard-input-box-3 select-custom-boxx" name="dexterity" placeholder="Dexterity" aria-label="Default select example" required value={item.dexterity} onChange={(e) => handleChangeiron(item.id, "dexterity", e.target.value)} disabled={!isEditing}>
                                                                                                    <option value="" selected>Dexterity</option>
                                                                                                    <option value="Righty">Righty</option>
                                                                                                    <option value="Lefty">Lefty</option>
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>


                                                                                    <div className='row pe-0 ' controlid="validationCustom016">
                                                                                        <div className='col-6 col-md-6 pe-0'>
                                                                                            <div className='form-group-input'>
                                                                                                <select className="form-select dashboard-input-box-3 select-custom-boxx" placeholder="Finish" aria-label="Default select example" required name="finish" value={item.finish} onChange={(e) => handleChangeiron(item.id, "finish", e.target.value)} disabled={!isEditing}>
                                                                                                    <option value="" selected>Finish</option>
                                                                                                    <option value="Satin Chrome">Satin Chrome</option>
                                                                                                    <option value="Black">Black</option>
                                                                                                    <option value="Copper">Copper</option>
                                                                                                    <option value="Champagne">Champagne</option>
                                                                                                    <option value="Night Train">Night Train</option>
                                                                                                    <option value="Flo-Rida">Flo-Rida</option>
                                                                                                    <option value="Blue">Blue</option>
                                                                                                    <option value="Raw">Raw</option>
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='col-6 col-md-6 pe-0'>
                                                                                            <div className='form-group-input'>
                                                                                                <select className="form-select dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required name="bounce" value={item.bounce} onChange={(e) => handleChangeiron(item.id, "bounce", e.target.value)} disabled={!isEditing}>
                                                                                                    <option value="" selected>Bounce</option>
                                                                                                    <option value="Low Bounce">Low Bounce</option>
                                                                                                    <option value="Mid Bounce">Mid Bounce</option>
                                                                                                    <option value="High Bounce">High Bounce</option>
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            ))}

                                                                            <div class="add-golfer-header mb-0 mt-3">
                                                                                <div class="add-golfer-header-text" style={{ color: "#f3fcff" }}>
                                                                                    <h3>Port Weights</h3>
                                                                                </div>
                                                                                <button type="button" className="btn-close" aria-label="Close" onClick={addItem} disabled={!isEditing}>
                                                                                    <FaPlus size={22} />
                                                                                </button>
                                                                            </div>
                                                                            {items.map((item) => (
                                                                                <div className="pos-fix row align-items-center pe-0 mt-2" key={item.id}>
                                                                                    <div className="col-2 col-sm-1 col-md-1 col-lg-2 col-xl-1">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="p-2"
                                                                                            style={{ backgroundColor: "#e72626", color: "#ffffff", borderRadius: "50%", border: "none" }}
                                                                                            onClick={() => removeItem(item.id)}
                                                                                            disabled={!isEditing}
                                                                                        >
                                                                                            <IoClose size={22} />
                                                                                        </button>
                                                                                    </div>
                                                                                    <div className="col-10 col-sm-4 col-md-4 pe-0 col-lg-10 col-xl-4">
                                                                                        <div className='form-group-input'>
                                                                                            {/* <select className="form-select dashboard-input-box-3" required value={item.finish} onChange={(e) => handleChange(item.id, "finish", e.target.value)} disabled={!isEditing}>
                                                                                                <option value="" selected>Finish</option>
                                                                                                {finishes.map((finish, index) => (
                                                                                                    <option key={index} value={finish}>{finish}</option>
                                                                                                ))}
                                                                                            </select> */}
                                                                                            <select
                                                                                                className="form-select dashboard-input-box-3 select-custom-boxx"
                                                                                                required
                                                                                                value={item.finish}
                                                                                                onChange={(e) => handleChange(item.id, "finish", parseInt(e.target.value))}
                                                                                                disabled={!isEditing}
                                                                                            >
                                                                                                <option value="">Finish</option>
                                                                                                {finishes.map((finish) => (
                                                                                                    <option key={finish.id} value={finish.id}>{finish.name}</option>
                                                                                                ))}
                                                                                            </select>

                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="margin col-6 col-sm-4 col-md-4 pe-0 col-lg-6 col-xl-4">
                                                                                        <div className='form-group-input'>
                                                                                            {/* <select className="form-select dashboard-input-box-3" required value={item.weight} onChange={(e) => handleChange(item.id, "weight", e.target.value)} disabled={!isEditing}>
                                                                                                <option value="" selected>Weight</option>
                                                                                                {weights.map((weight, index) => (
                                                                                                    <option key={index} value={weight}>{weight}</option>
                                                                                                ))}
                                                                                            </select> */}
                                                                                            <select
                                                                                                className="form-select dashboard-input-box-3 select-custom-boxx"
                                                                                                required
                                                                                                value={item.weight}
                                                                                                onChange={(e) => handleChange(item.id, "weight", e.target.value)}
                                                                                                disabled={!isEditing}
                                                                                            >
                                                                                                <option value="">Weight</option>
                                                                                                {(weightsByFinish[item.finish] || []).map((weight, index) => (
                                                                                                    <option key={index} value={weight}>{weight}</option>
                                                                                                ))}
                                                                                            </select>

                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="margin col-6 col-sm-3 col-md-3 pe-0 col-lg-6 col-xl-3">
                                                                                        <div className='form-group-input'>
                                                                                            <select className="form-select dashboard-input-box-3 select-custom-boxx" required value={item.qty} onChange={(e) => handleChange(item.id, "qty", e.target.value)} disabled={!isEditing}>
                                                                                                <option value="" selected>Qty</option>
                                                                                                {quantity.map((qty, index) => (
                                                                                                    <option key={index} value={qty}>{qty}</option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}


                                                                            <div class="add-golfer-header mb-0 mt-3">
                                                                                <div class="add-golfer-header-text" style={{ color: "#f3fcff" }}>
                                                                                    <h3>Counter Weights</h3>
                                                                                </div>
                                                                                <button type="button" className="btn-close" aria-label="Close" onClick={addCounters} disabled={!isEditing}>
                                                                                    <FaPlus size={22} />
                                                                                </button>
                                                                            </div>

                                                                            {countersets.map((item) => (
                                                                                <div className="pos-fix row align-items-center pe-0 mt-2" key={item.id}>
                                                                                    <div className="col-2 col-sm-1 col-md-1 col-lg-2 col-xl-1">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="p-2"
                                                                                            style={{ backgroundColor: "#e72626", color: "#ffffff", borderRadius: "50%", border: "none" }}
                                                                                            onClick={() => removeCounter(item.id)}
                                                                                            disabled={!isEditing}
                                                                                        // disabled={items.length === 1}
                                                                                        >
                                                                                            <IoClose size={22} />
                                                                                        </button>
                                                                                    </div>
                                                                                    <div className="col-10 col-sm-4 col-md-4 pe-0 col-lg-10 col-xl-4">
                                                                                        <div className='form-group-input'>
                                                                                            <select className="form-select dashboard-input-box-3 select-custom-boxx" required value={item.size} onChange={(e) => handleChangecounter(item.id, "size", e.target.value)} disabled={!isEditing}>
                                                                                                <option value="" selected>Size</option>
                                                                                                {sizearray.map((size, index) => (
                                                                                                    <option key={index} value={size}>{size}</option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="margin col-6 col-sm-4 col-md-4 pe-0 col-lg-6 col-xl-4">
                                                                                        <div className='form-group-input'>
                                                                                            <select className="form-select dashboard-input-box-3 select-custom-boxx" required value={item.weight} onChange={(e) => handleChangecounter(item.id, "weight", e.target.value)} disabled={!isEditing}>
                                                                                                <option value="" selected>Weight</option>
                                                                                                {counterweight.map((weight, index) => (
                                                                                                    <option key={index} value={weight}>{weight}</option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="margin col-6 col-sm-3 col-md-3 pe-0 col-lg-6 col-xl-3">
                                                                                        <div className='form-group-input'>
                                                                                            <select className="form-select dashboard-input-box-3 select-custom-boxx" required value={item.qty} onChange={(e) => handleChangecounter(item.id, "qty", e.target.value)} disabled={!isEditing}>
                                                                                                <option value="" selected>Qty</option>
                                                                                                {quantity.map((value, index) => (
                                                                                                    <option key={index} value={value}>{value}</option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}

                                                                            <div class="add-golfer-header mb-0 mt-3">
                                                                                <div class="add-golfer-header-text" style={{ color: "#f3fcff" }}>
                                                                                    <h3>Weight Notes</h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom015">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <textarea type="text" class="form-control dashboard-input-box-3" placeholder="Swing weight / counter balance notes..." style={{ height: "20vh" }} required name="weightNotes" value={formData.weightNotes} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="add-golfer-header mb-0 mt-3">
                                                                                <div class="add-golfer-header-text" style={{ color: "#f3fcff" }}>
                                                                                    <h3>General Notes</h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row pe-0' controlid="validationCustom015">
                                                                                <div className='col-md-12 pe-0'>
                                                                                    <div className='form-group-input'>
                                                                                        <textarea type="text" class="form-control dashboard-input-box-3" placeholder="Anything we need to know..." style={{ height: "20vh" }} required name="generalNotes" value={formData.generalNotes} onChange={handleFormChange} disabled={!isEditing} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </Form>
                                                                </div>
                                                            </div>
                                                            <div className='full-width-btn pe-0'>
                                                                {/* {
                                                                    apiupate ? (<button className="btn btn-remove btn_disabled" disabled>...Remove Order</button>)
                                                                        : (<button className="btn btn-remove btn_disabled" onClick={handleShowConfirmation2}>Remove Order</button>)
                                                                } */}
                                                                <button className="btn btn-remove btn_disabled" onClick={handleShowConfirmation2}>Remove Order</button>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec ">
                                                            <div className="fix_sec_view">
                                                                <div className='select-dropdown-build mt-0'>
                                                                    <div className={`select-options-dropdown ${isOpen2 ? 'open' : ''}`}>
                                                                        <div className='select-option-inner' onClick={toggleDropdown2} >
                                                                            <span className={`icon-color color-${getColorClass()}`}></span>
                                                                            <div className='selected-option-text'>{selectedOption2}</div>
                                                                            <span className={`icon ${isOpen2 ? 'up' : 'down'}`}>
                                                                                <i className="bi bi-chevron-down" />
                                                                            </span>
                                                                        </div>

                                                                        {isOpen2 && (
                                                                            <div className='option-list buildsheet-option-list'>
                                                                                <div className='drop-down-list'>
                                                                                    {options2.map(option => (
                                                                                        <div
                                                                                            key={option.text}
                                                                                            className={`drop-down-item ${selectedOption2 === option.text ? 'active' : ''}`}
                                                                                            onClick={() => selectOption2(option)}
                                                                                        >
                                                                                            <div className='drop-down-item-icon'>
                                                                                                <span className={`icon-color color-${option.color}`}> </span>
                                                                                            </div>
                                                                                            <div className='drop-down-item-text'>{option.text}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                                <div className='form-box-section'>
                                                                                    {
                                                                                        // selectedOption2 === "Inquiry" || selectionid === dbselectionid ? (
                                                                                        selectionid === dbselectionid ? (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                disabled
                                                                                            >
                                                                                                <span>Update Status</span>
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                onClick={updateStagestatus}
                                                                                            >

                                                                                                {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                            </button>
                                                                                        )
                                                                                    }

                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className='design_hide_mobile'>
                                                                    <div className="tab-box-section notes-tab">
                                                                        <div className="form-group">
                                                                            <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" rows="10" value={notes} onChange={(e) => setnotes(e.target.value)} placeholder="Leave your note here..." ></textarea>
                                                                            {
                                                                                showerror && <div className="error-msg " style={{ color: 'red' }}>Please enter notes</div>
                                                                            }
                                                                        </div>
                                                                        <div className='text-center'>
                                                                            <button className="btn btn-create" onClick={handleaddnotes}><span>{apicall ? <Spinner animation="border" className="border-black" /> : "Add Note"}</span></button>
                                                                        </div>
                                                                    </div>
                                                                    <>
                                                                        {
                                                                            notesdata.length === 0 ? (
                                                                                <div className="tab-box-section notes-tab mt-4">
                                                                                    <div className='no-data-img'>
                                                                                        <img src={require("../assets/images/logo_text.png")} alt="" />
                                                                                    </div>
                                                                                    <div className="no-data-text">
                                                                                        <h3>No data Found</h3>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                                :
                                                                                notesdata.map((item, i) => {
                                                                                    return (
                                                                                        <div className="dashboard-sec new_activity">
                                                                                            <div className="tab-box-section activity-form-box">
                                                                                                <div className="form-list-inner">
                                                                                                    <div className="form-list-title activity-title">
                                                                                                        <div className="emp-name">
                                                                                                            <div className="emp-light">Employee:</div>
                                                                                                            <div className="emp-bold">{item ? item.customer : ''}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="form-card-body-status">
                                                                                                        {item.notes}
                                                                                                    </div>
                                                                                                    <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                        }
                                                                    </>
                                                                </div>
                                                                <div className='design_show_mobile'>
                                                                    <div className="tab-box-section notes-tab">
                                                                        <div className="form-group">
                                                                            <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" value={notes} onChange={(e) => setnotes(e.target.value)} rows="10" placeholder="Leave your note here..." ></textarea>
                                                                            {
                                                                                showerror && <div className="error-msg " style={{ color: 'red' }}>Please enter notes</div>
                                                                            }
                                                                        </div>
                                                                        <div className='text-center'>
                                                                            <button className="btn btn-create" onClick={handleaddnotes}><span>{apicall ? <Spinner animation="border" className="border-black" /> : "Add Note"}</span></button>
                                                                        </div>
                                                                    </div>
                                                                    <>
                                                                        {
                                                                            notesdata.length === 0 ? (
                                                                                <div className="tab-box-section notes-tab mt-4">
                                                                                    <div className='no-data-img'>
                                                                                        <img src={require("../assets/images/logo_text.png")} alt="" />
                                                                                    </div>
                                                                                    <div className="no-data-text">
                                                                                        <h3>No data Found</h3>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                                :
                                                                                notesdata.map((item, i) => {
                                                                                    return (
                                                                                        <div className="dashboard-sec new_activity">
                                                                                            <div className="tab-box-section activity-form-box">
                                                                                                <div className="form-list-inner">
                                                                                                    <div className="form-list-title activity-title">
                                                                                                        <div className="emp-name">
                                                                                                            <div className="emp-light">Employee:</div>
                                                                                                            <div className="emp-bold">{item ? item.customer : ''}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="form-card-body-status">
                                                                                                        {item.notes}
                                                                                                    </div>
                                                                                                    <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                        }
                                                                    </>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>










                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                        <style>
                            {`
                                .btn-remove{
                                    border-radius: 15px !important;
                                    color: #ffffff !important;
                                }
                                .form-select:disabled {
                                    background-color: #41464f !important;
                                    pointer-events: none !important;
                                }
                                
                                @media only screen and (min-width: 991px){
                                .right_fix_sec {    
                                    height: calc(100vh - 300px);
                                    transition: .3s;
                                    right: 0;
                                    overflow-y: auto;
                                }
                                    .dashboard_first {
                                    flex: 0 0 640px;
                                    max-width: 640px;
                                    width: 100%;
                                }
                            }
                                // @media only screen and (min-width: 1601px) and (max-width: 1919px) {
                                //     .dashboard_first {
                                //         flex: 0 0 640px; 
                                //         max-width: 640px; 
                                //         width: 100%; 
                                //     }
                                // }
                            `}
                        </style>
                    </>
                )
            }
        </>
    )
}

function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${month}/${day}/${year}`;
}

export default FitterBuilderOrder
